"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("../../../../Button/Button"));
var Basic = function Basic(_ref) {
  var size = _ref.size,
    heading = _ref.heading,
    subheading = _ref.subheading,
    whiteFont = _ref.whiteFont,
    cta = _ref.cta,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-u-relative image--basic flex flex-column justify-end height-100% ".concat(size)
  }, children ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-component"
  }, heading && /*#__PURE__*/_react["default"].createElement("h3", {
    className: (0, _classnames["default"])('card--image__heading', 'd8-u-ls-sm', 'text-md', whiteFont && 'd8-u-color-white')
  }, heading), subheading && /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _classnames["default"])('text-sm', 'd8-u-ls-sm', whiteFont && 'd8-u-color-white')
  }, subheading)), cta && /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-top-md"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: cta.id,
    className: cta.className,
    text: cta.text,
    link: cta.link,
    buttonType: cta.buttonType,
    external: cta.external
  }))));
};
Basic.propTypes = {
  size: _propTypes["default"].string,
  heading: _propTypes["default"].string,
  subheading: _propTypes["default"].string,
  whiteFont: _propTypes["default"].bool,
  cta: _propTypes["default"].object,
  children: _propTypes["default"].any
};
Basic.defaultProps = {
  heading: null,
  subheading: null,
  whiteFont: false,
  cta: null
};
var _default = exports["default"] = Basic;